import api from "../api";

export interface ResponseGenerica<T> {
    datos: T[],
    error?: string
}

export interface IMaquinaEstado {
    id: number;
    objetivos: string;
}

export interface IMaquina {
    codBien: string;
    estado: number;
    condicion_id: number | null;
    calificacion_id?: number;
    calificacion: number | null;
    descripcion?: string;
    dimensionObjeto?: string;
    nombre?: string;
    origen?: string;
    descripcion_problema?: string | null; 
}
export interface IMaquinaPost {
    
    calificacion_id: number,
    maquina_codigo: string,
    maquina_descripcion: string,
    estado: number
    
}

export interface IResponseMaquinas {
    calificacion : number;
    codBien : string;
    comentario: string;
    maquinas: IMaquina[];
}

export interface IPostMaquina {
    datos: {
        comentario: string;
        maquinas: IMaquina[];
      }[];
}
export interface IResponsePostMaquina {
    exito: boolean;
    info?: string;
  }

const API_URL_MAQUINAS = `fiscalizacion/maquinas`;
const API_URL_LP = `fiscalizacion/lavado_profundo/estados`;


export const fetchMaquinas = async (puntoservicioId: number): Promise<ResponseGenerica<IResponseMaquinas>> => {
    try {
        const response = await api.get(`${API_URL_MAQUINAS}/${puntoservicioId}`);

        if (response.data && response.data.datos) {
            return {
                datos: response.data.datos,
            };
        } else {
            return {
                datos: [],
                error: "No se encontraron máquinas"
            };
        }
    } catch (error) {
        console.error('Error en fetchMaquinas:', error);
        return {
            datos: [],
            error: "Error al obtener las máquinas"
        };
    }
};


export const postMaquinas = async (postData, fiscalizacion_id:number): Promise<IResponsePostMaquina> => {
    try {
        const response = await api.post(`${API_URL_MAQUINAS}/${fiscalizacion_id}`, postData);
        console.log(response.data.info)
        if (response.data && response.data.exito) {
            return response.data;
        } else {
            return {
                exito: true,
                info: response.data.info ?? "Error al procesar información de las máquinas"
            };
        }
    } catch (error) {
        console.error('Error en postMaquinas:', error);
        return {
            exito: false,
            info: "Error inesperado al procesar información de las máquinas"
        };
    }
};

export const fetchLP = async (): Promise<ResponseGenerica<IMaquinaEstado[]>> => {
    try {
        const response = await api.get(`${API_URL_LP}`);

        if (response.data && response.data.datos) {
            return {
                datos: response.data.datos,
            };
        } else {
            return {
                datos: [],
                error: "No se encontraron estados"
            };
        }
    } catch (error) {
        console.error('Error en fetchLP:', error);
        return {
            datos: [],
            error: "Error al obtener los estados"
        };
    }
}